import React from 'react';
import DesktopHeader from './DesktopHeader';
import DesktopFooter from './DesktopFooter';
import GeneralFeedbackBubble from '../chat/GeneralFeedbackBubble';
import DesktopChatDock from '../chat/DesktopChatDock';

const DesktopLayout = ({ children, hideFooter = false }) => {
    return (
        <div className="w-full min-h-screen bg-gray-50 flex flex-col font-sans">
            <DesktopHeader />
            <main className="flex-1 pt-20">
                {children}
            </main>
            {!hideFooter && <DesktopFooter />}
            <GeneralFeedbackBubble />
            <DesktopChatDock />
        </div>
    );
};

export default DesktopLayout;

